import React from "react";

import FileUpload from "./FileUpload";
import SnackBar from './../SnackBar'

export default class DragDrop extends React.Component {
  state = {
    files: [],
    snackbarActive: false,
    snackbarMessage: ''
  };

  componentWillUnmount() {
    // Make sure to revoke the data uris to avoid memory leaks
    this.state.files.forEach(file => URL.revokeObjectURL(file.preview));
  }

  addFile = file => {
    console.log(file);
    this.setState({
      files: file.map(file =>
        Object.assign(file, {
          preview: URL.createObjectURL(file)
        })
      )
    });
  };

  render() {
    return (    
      <React.Fragment>
          <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
        <FileUpload 
                addFile={this.addFile} 
                files={this.state.files}  
                fileBaseValue={(base64Data,file)=>{        
                  this.props.fileUpdate(base64Data,file)                       
                }}
                hasFileError = {
                  (e)=>{
                    this.setState({
                      snackbarActive: true,
                      snackbarMessage:'Please upload pdf file having maximum size of 5MB.'
                    })
                  }
                }
                fileName={this.props.fileName}
                />    
                </React.Fragment>
    );
  }
}
